import { useState } from "react";
import {
  Modal,
  Button,
  ButtonVariant,
  IconButton,
  Radio
} from "shared/components";
import { ApplicantType } from "shared/types";
import { cx } from "shared/utils";

import { XClose } from "untitledui-js-base";
import { FullApplicant } from "views/applications-id/components/ApplicantsTable/types";

const roles = [
  {
    value: ApplicantType.Applicant,
    label: "Applicant",
    description:
      "Anyone over 18 living in the property, such as a roommate, spouse, or partner"
  },
  {
    value: ApplicantType.CoSigner,
    label: "Guarantor",
    description:
      "A person who won't live in the property but will provide financial support"
  }
];

export const ChangeRoleModal = ({
  onClose,
  onChange,
  applicant,
  isOpen
}: {
  onClose: () => void;
  onChange: (role: ApplicantType) => void;
  applicant?: FullApplicant;
  isOpen: boolean;
}) => {
  const [selectedRole, setSelectedRole] = useState(
    applicant?.role as ApplicantType
  );

  return (
    <Modal
      opened={isOpen}
      onClose={onClose}
      panelClassName="max-w-[670px] w-full"
    >
      <div className="p-6 border-b border-alpha-100">
        <div className="flex items-center justify-between">
          <h1 className="text-xl text-content-1000 font-bold">
            Change role for {applicant?.first_name} {applicant?.last_name}
          </h1>
          <IconButton
            onClick={onClose}
            borderLess
            className="ml-auto translate-x-2"
            Icon={XClose}
          />
        </div>
        <p className="text-sm text-content-500">
          Application will use the screening settings for the selected role.
          Application will keep the original set of requested information, but
          any missing reports will be added.
        </p>
      </div>
      <div className="px-6 py-4 bg-background-900">
        <div className="flex items-center justify-between gap-4">
          {roles.map((role) => (
            <div
              key={role.value}
              className={cx(
                "bg-background-1000 gap-4 rounded-lg p-6",
                selectedRole === role.value
                  ? "border border-primary-100 border-opacity-0"
                  : "border border-alpha-100 border-opacity-0"
              )}
            >
              <Radio
                id="role-user"
                name="role"
                checked={selectedRole === role.value}
                onChange={() => setSelectedRole(role.value)}
              />
              <p className="text-sm font-bold pt-5">{role.label}</p>
              <p className="text-sm font-normal text-content-400 pt-2">
                {role.description}
              </p>
            </div>
          ))}
        </div>
      </div>
      <div className="flex justify-end px-6 py-4 border-t border-alpha-100 gap-2">
        <Button onClick={onClose}>Cancel</Button>
        <Button
          variant={ButtonVariant.PRIMARY}
          onClick={() => onChange(selectedRole as ApplicantType)}
        >
          Change
        </Button>
      </div>
    </Modal>
  );
};
